<template>
    <div class="z-40 bg-black opacity-75 fixed inset-0" @click="emitClick" />
</template>

<script>
export default {
    methods: {
        emitClick() {
            this.$emit('click');
        },
    },
};
</script>
